const Constants = {
  layout_dimension_changed: 'mcb.layout_dimension_changed',
}

export default Constants;
